/** The door: sign in, or — on a server nobody has used yet — make the first account. */
import { useState } from 'react'
import { WorkspaceMark } from './icons'
import { Btn, Field, inputCls } from './kit'
import { useDemo } from './store'

export function SignIn() {
  const first = useDemo((s) => s.setupRequired)
  const login = useDemo((s) => s.login)
  const setup = useDemo((s) => s.setup)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [name, setName] = useState('')
  const [busy, setBusy] = useState(false)
  const [problem, setProblem] = useState('')
  const ok = username.trim().length > 0 && password.length >= (first ? 8 : 1)
  const submit = async () => {
    if (!ok || busy) return
    setBusy(true)
    setProblem('')
    try {
      if (first) await setup(username.trim(), password, name.trim() || undefined)
      else await login(username.trim(), password)
    } catch (e) {
      setProblem(e instanceof Error ? e.message : 'That did not work')
    } finally {
      setBusy(false)
    }
  }
  return (
    <div className="ws flex min-h-full items-center justify-center bg-ws-bg px-4">
      <form
        className="w-full max-w-[340px]"
        onSubmit={(e) => {
          e.preventDefault()
          void submit()
        }}
      >
        <div className="flex flex-col items-center">
          <WorkspaceMark size={28} />
          <h1 className="m-0 mt-5 font-ws-serif text-[28px] font-normal leading-9 tracking-normal text-ws-fg">Libera</h1>
          <p className="m-0 mt-2 text-center text-[12px] leading-[18px] tracking-normal text-ws-fg-3">{first ? 'Nobody has used this server yet. The first account runs it.' : 'Sign in to your agents.'}</p>
        </div>
        <div className="mt-8 space-y-4">
          {first && (
            <Field label="Your name" hint="Optional">
              <input value={name} onChange={(e) => setName(e.target.value)} className={inputCls} autoComplete="name" />
            </Field>
          )}
          <Field label="Username">
            <input value={username} onChange={(e) => setUsername(e.target.value)} className={inputCls} autoComplete="username" autoCapitalize="none" spellCheck={false} autoFocus />
          </Field>
          <Field label="Password" hint={first ? 'At least 8 characters' : undefined}>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" className={inputCls} autoComplete={first ? 'new-password' : 'current-password'} />
          </Field>
        </div>
        {problem && <p className="m-0 mt-4 text-[12px] leading-[18px] tracking-normal text-ws-down">{problem}</p>}
        <Btn variant="white" type="submit" disabled={!ok || busy} className="mt-6 w-full">
          {busy ? 'One moment…' : first ? 'Create the account' : 'Sign in'}
        </Btn>
      </form>
    </div>
  )
}
